import React from 'react';

const StatusButton = ({ status,id, currentStatus, onClick, punchInTime, punchOutTime }) => {
  const getButtonText = () => {
    if (status === "PRESENT" && currentStatus === "PRESENT") {
      return `P I ${formatTime(punchInTime)} - ${formatTime(punchOutTime)}`;
    }
    if (status === "HALFDAY" && currentStatus === "HALFDAY") {
      return `H I ${formatTime(punchInTime)} - ${formatTime(punchOutTime)}`;
    }
    return `${status.charAt(0)} I ${status}`;
  };

  const formatTime = (time) => {
    return time
      ? new Date(time).toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
      : "N/A";
  };

  const getButtonClass = () => {
    let baseClass = "btns px-6 py-3 text-[14px] font-medium rounded-md focus:outline-none w-full xl:w-[200px] lg:w-[142px] md:w-[140px] whitespace-nowrap shadow-md ";
    if (currentStatus === status) {
      return baseClass + (status === "ABSENT" ? "bg-[#d62727] text-white" : "bg-[#008000] text-white");
    }
    return baseClass + "bg-[#fff] text-[#000]";
  };

  return (
    <button onClick={onClick} className={getButtonClass()}>
      {getButtonText()}
    </button>
  );
};

export default StatusButton;
  